import {
  Box,
  Grid,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableHead,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DoctorconsoleGrid, OutlinedIconFab } from "../StyledComponents";
import Icon from "../Utils/Icons";

export const AttachmentsFilePreview = ({
  data,
  activeSection,
  handleAttachmentPreviewModalOpen = () => {},
  handleDeleteAttachment = () => {},
  closeAttachmentPreviewModal = () => {},
  attachmentPreviewModalOpen = false,
  selectedAttachmentForPreview = null,
}) => {
  if (!data || data.length === 0) return null;

  return (
    <>
      {activeSection && data.length === 0 ? (
        <DoctorconsoleGrid item xs={12}>
          <DoctorconsoleGrid container direction="column" alignItems="center">
            <img
              src="/img/medications.jpeg"
              alt="Placeholder"
              height="100"
              width="100"
              style={{ borderRadius: "50%" }}
            />
            <Typography variant="body1" sx={{ marginTop: 1 }}>
              Selected Files will be shown here
            </Typography>
          </DoctorconsoleGrid>
        </DoctorconsoleGrid>
      ) : data.length > 0 ? (
        <DoctorconsoleGrid item xs={12}>
          <DoctorconsoleGrid
            container
            sx={{
              padding: 1,
              maxHeight: "150px",
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            {data.length > 0 &&
              data.map((file, index) => (
                <Grid
                  key={index}
                  container
                  item
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    backgroundColor: "#E9FAF9",
                    "&:hover": {
                      backgroundColor: "#5caff4ff",
                    },
                    borderRadius: 2,
                    marginBottom: 1,
                    padding: 1,
                    cursor: activeSection ? "pointer" : "default",
                  }}
                >
                  <Grid
                    item
                    xs={10}
                    onClick={() =>
                      activeSection && handleAttachmentPreviewModalOpen(file)
                    }
                  >
                    <Typography variant="body2">{file.name}</Typography>
                  </Grid>
                  <Grid item xs={2}>
                    {activeSection && file && (
                      <OutlinedIconFab
                        onClick={() => handleDeleteAttachment(index)}
                      >
                        <Icon name="deleteInTable" size={32} />
                      </OutlinedIconFab>
                    )}
                  </Grid>
                </Grid>
              ))}
          </DoctorconsoleGrid>
        </DoctorconsoleGrid>
      ) : null}

      {activeSection && (
        <Modal
          open={attachmentPreviewModalOpen}
          onClose={closeAttachmentPreviewModal}
        >
          <Box className="modal-box">
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <IconButton onClick={closeAttachmentPreviewModal}>
                <CloseIcon />
              </IconButton>
            </div>
            <div style={{ padding: "16px" }}>
              <h1 className="console-heading">
                {selectedAttachmentForPreview !== null &&
                  selectedAttachmentForPreview.name}
              </h1>
              {selectedAttachmentForPreview !== null &&
              selectedAttachmentForPreview.type === "application/pdf" ? (
                <iframe
                  src={
                    selectedAttachmentForPreview !== null &&
                    selectedAttachmentForPreview.base64 + "#toolbar=0"
                  }
                  title={
                    selectedAttachmentForPreview !== null &&
                    selectedAttachmentForPreview.name
                  }
                  width="100%"
                  height="200%"
                  style={{ border: "none" }}
                ></iframe>
              ) : (
                <img
                  src={
                    selectedAttachmentForPreview !== null &&
                    selectedAttachmentForPreview.base64 + "#toolbar=0"
                  }
                  alt={
                    selectedAttachmentForPreview !== null &&
                    selectedAttachmentForPreview.name
                  }
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
              )}
            </div>
          </Box>
        </Modal>
      )}
    </>
  );
};
